"use strict";
const options = {
  collectionsLoadMore: ".collections-load-more",
  blsLinkFilter: ".bls__link-filter",
  openFilter: ".filter-title .open-children-toggle",
  rangeSlider: ".price-range .range-slider",
  rangeSliderMin: ".range-slider-min",
  rangeSliderMax: ".range-slider-max",
  gridMode: ".grid-mode-show-type-products .grid-mode",
  viewMode: ".view-mode",
  sidebarClose: ".sidebar-close",
  collectionSidebar: "#CollectionSidebar",
  collectionFiltersForm: "#CollectionFiltersForm",
  btnFilter: ".collection-filter .btn-filter",
  section: ".section-collection-product",
  toolbarSorter: ".toolbar-sorter .select-selected",
  facetFiltersSort: ".facet-filters__sort li",
  overlay: ".bls__overlay",
  filterSortMb: ".toolbar-sorter-mb .facet-filters__label",
  dataSortMb: ".toolbar-sorter-mb__option",
  closeSortMb: ".close-select",
};
var BlsEventCollectionShopify = {
  init: function () {
    this.setupEventListeners(),
      this.eventLoadMore(),
      this.ionRangeSlider(),
      this.actionDesc();
  },
  actionDesc: function () {
    let e = document.querySelector("[data-view-more]");
    e &&
      e.addEventListener("click", function (e) {
        let t = e.currentTarget;
        t.closest(".heading-description").classList.contains("show-full-desc")
          ? (t
              .closest(".heading-description")
              .classList.remove("show-full-desc"),
            (t.textContent = t.dataset.readMore))
          : (t.closest(".heading-description").classList.add("show-full-desc"),
            (t.textContent = t.dataset.readLess));
      });
  },
  setupEventListeners: function () {
    document.querySelectorAll(options.btnFilter).forEach((e) => {
      e.addEventListener(
        "click",
        (e) => {
          e.preventDefault();
          let t = e.currentTarget;
          document
            .querySelector(options.collectionSidebar)
            .classList.contains("bls__opend-popup")
            ? (t.classList.remove("actived"),
              document
                .querySelector(options.collectionSidebar)
                .classList.remove("bls__opend-popup"),
              document
                .querySelector(options.overlay)
                .classList.add("d-none-overlay"),
              document.documentElement.classList.remove("hside_opened"),
              t
                .closest(".collection-filter")
                .classList.contains("dropdonw_sidebar") &&
                window.innerWidth >= 1024 &&
                slideAnime({
                  target: t
                    .closest("#productgridcontainer")
                    .querySelector("#CollectionSidebar"),
                  animeType: "slideToggle",
                }),
              t.classList.remove("actived"))
            : (t.classList.add("actived"),
              document
                .querySelector(options.collectionSidebar)
                .classList.add("bls__opend-popup"),
              t
                .closest(".collection-filter")
                .classList.contains("dropdonw_sidebar")
                ? window.innerWidth < 1024
                  ? (document
                      .querySelector(options.overlay)
                      .classList.remove("d-none-overlay"),
                    document.documentElement.classList.add("hside_opened"))
                  : slideAnime({
                      target: t
                        .closest("#productgridcontainer")
                        .querySelector("#CollectionSidebar"),
                      animeType: "slideToggle",
                    })
                : (document
                    .querySelector(options.overlay)
                    .classList.remove("d-none-overlay"),
                  document.documentElement.classList.add("hside_opened")));
        },
        !1
      );
    }),
      document.querySelectorAll(options.openFilter).forEach((e) => {
        e.addEventListener(
          "click",
          (e) => {
            e.preventDefault();
            let t = e.currentTarget;
            slideAnime({
              target: t
                .closest(".filter-item")
                .querySelector(".filter-content"),
              animeType: "slideToggle",
            }),
              t.classList.contains("active")
                ? t.classList.remove("active")
                : t.classList.add("active");
          },
          !1
        );
      }),
      document.querySelectorAll(options.sidebarClose).forEach((e) => {
        e.addEventListener(
          "click",
          (e) => {
            e.preventDefault(),
              document
                .querySelector(options.collectionSidebar)
                .classList.remove("bls__opend-popup"),
              document.querySelector(options.btnFilter) &&
                document
                  .querySelector(options.btnFilter)
                  .classList.remove("actived"),
              document
                .querySelector(options.overlay)
                .classList.add("d-none-overlay"),
              document.documentElement.classList.remove("hside_opened");
          },
          !1
        );
      }),
      document.querySelectorAll(options.viewMode).forEach((e) => {
        e.addEventListener(
          "click",
          (e) => {
            e.preventDefault();
            let t = e.currentTarget,
              r = t.getAttribute("data-view");
            if (t.classList.contains("actived")) return;
            var o = window.location.search;
            if (((o = this.removeParam("view", o)), "list" == r))
              var l = o.replace("?", "") + "&view=list";
            else var l = o.replace("?", "") + "&view=grid";
            let i = this.renderUrl(l);
            this.renderSectionFilter(i, l);
          },
          !1
        );
      }),
      document.querySelectorAll(options.gridMode).forEach((e) => {
        e.addEventListener(
          "click",
          (e) => {
            e.preventDefault();
            let t = e.currentTarget,
              r = t.getAttribute("data-grid-mode");
            if (t.classList.contains("actived") || 1 == r) return;
            for (var o of document.querySelectorAll(options.gridMode))
              o.classList.remove("actived");
            let l = document.querySelector(".container-products-switch");
            t.classList.add("actived");
            let i = l.getAttribute("data-view-mode");
            l.classList.remove("grid-columns-" + i),
              l.setAttribute("data-view-mode", r),
              l.classList.add("grid-columns-" + r);
          },
          !1
        );
      }),
      document.querySelectorAll(options.blsLinkFilter).forEach((e) => {
        e.addEventListener(
          "click",
          (e) => {
            e.preventDefault();
            let t = e.currentTarget;
            t.querySelector(".bls_tooltip")
              ? t
                  .querySelector(".bls_tooltip")
                  .classList.toggle("current-filter")
              : t.closest("li").classList.toggle("current-filter");
            let r = t.getAttribute("href");
            this.renderSectionFilter(r);
          },
          !1
        );
      }),
      document.body.addEventListener("click", (e) => {
        let t = e.target,
          r = document.querySelector(
            ".collection-filter.dropdonw_sidebar .btn-filter"
          );
        !t.closest(".select-custom") &&
          t != document.querySelector(".toolbar-sorter .select-custom") &&
          document.querySelector(".toolbar-sorter .select-custom") &&
          document
            .querySelector(".toolbar-sorter .select-custom")
            .classList.remove("actived"),
          !t.closest("#CollectionSidebar") &&
            t != document.querySelector("#CollectionSidebar") &&
            r &&
            t != r &&
            window.innerWidth >= 1024 &&
            (r.classList.remove("actived"),
            document
              .querySelector(options.collectionSidebar)
              .classList.remove("bls__opend-popup"),
            document
              .querySelector(options.overlay)
              .classList.add("d-none-overlay"),
            document.documentElement.classList.remove("hside_opened"),
            slideAnime({
              target: r
                .closest("#productgridcontainer")
                .querySelector("#CollectionSidebar"),
              animeType: "slideUp",
            }));
      }),
      document.querySelectorAll(options.toolbarSorter).forEach((e) => {
        e.addEventListener(
          "click",
          (e) => {
            e.preventDefault();
            let t = e.currentTarget;
            t.closest(".select-custom").classList.contains("actived")
              ? t.closest(".select-custom").classList.remove("actived")
              : t.closest(".select-custom").classList.add("actived");
          },
          !1
        );
      }),
      document.querySelector(options.filterSortMb) &&
        document.querySelector(options.filterSortMb).addEventListener(
          "click",
          (e) => {
            e.preventDefault();
            let t = e.currentTarget;
            t.closest(".toolbar-sorter-mb").classList.contains("open-selected")
              ? t
                  .closest(".toolbar-sorter-mb")
                  .classList.remove("open-selected")
              : t.closest(".toolbar-sorter-mb").classList.add("open-selected");
          },
          !1
        ),
      document.querySelector(options.closeSortMb) &&
        document
          .querySelector(options.closeSortMb)
          .addEventListener("click", (e) => {
            e.preventDefault(),
              document
                .querySelector(".toolbar-sorter-mb")
                .classList.remove("open-selected");
          }),
      document.querySelectorAll(options.facetFiltersSort).forEach((e) => {
        e.addEventListener(
          "click",
          (e) => {
            e.preventDefault();
            let t = e.currentTarget,
              r = t.getAttribute("value");
            var o = window.location.search,
              l =
                (o = this.removeParam("sort_by", o)).replace("?", "") +
                "&sort_by=" +
                r;
            let i = this.renderUrl(l);
            this.renderSectionFilter(i, l);
          },
          !1
        );
      });
  },
  ionRangeSlider: function () {
    let e = document.querySelector(".price-range"),
      t = document.querySelector(options.rangeSliderMax),
      r = document.querySelector(options.rangeSliderMin),
      o = document.querySelector(".min-price-range"),
      l = document.querySelector(".max-price-range");
    var i = 0,
      s = 0;
    e &&
      (document.querySelector(options.rangeSliderMin).addEventListener(
        "input",
        (e) => {
          e.preventDefault();
          let l = e.currentTarget;
          Number(t.value) - Number(l.value) >= 1
            ? ((o.value = Number(l.value)), (i = 100 * Number(l.value)))
            : ((l.value = Number(t.value) - 1),
              (i = (Number(t.value) - 1) * 100));
          let s = Shopify.formatMoney(i, cartStrings.money_format);
          (document.querySelector(".price-lable .min").innerHTML = s),
            l
              .closest(".price-range")
              .style.setProperty(
                "--range-from",
                (r.value / Number(l.getAttribute("max"))) * 100 + "%"
              );
        },
        !1
      ),
      document.querySelector(options.rangeSliderMax).addEventListener(
        "input",
        (e) => {
          e.preventDefault();
          let o = e.currentTarget;
          o.value - r.value >= 1
            ? ((l.value = o.value), (s = 100 * Number(o.value)))
            : ((o.value = Number(r.value) + Number(1)),
              (s = (Number(r.value) + Number(1)) * 100));
          let i = Shopify.formatMoney(s, cartStrings.money_format);
          (document.querySelector(".price-lable .max").innerHTML = i),
            o
              .closest(".price-range")
              .style.setProperty(
                "--range-to",
                (t.value / Number(o.getAttribute("max"))) * 100 + "%"
              );
        },
        !1
      ),
      document.querySelectorAll(options.rangeSlider).forEach((e) => {
        e.addEventListener(
          "change",
          (e) => {
            e.preventDefault(), e.currentTarget;
            let t = new FormData(
                document.querySelector(options.collectionFiltersForm)
              ),
              r = new URLSearchParams(t).toString(),
              i = o.getAttribute("name"),
              s = l.getAttribute("name");
            var n = window.location.search;
            n = this.removeParam(i, n);
            var c = (n = this.removeParam(s, n)).replace("?", "") + "&" + r;
            let a = this.renderUrl(c);
            this.renderSectionFilter(a, c);
          },
          !1
        );
      }));
  },
  removeParam: function (e, t) {
    var r,
      o = t.split("?")[0],
      l = [],
      i = -1 !== t.indexOf("?") ? t.split("?")[1] : "";
    if ("" !== i) {
      l = i.split("&");
      for (var s = l.length - 1; s >= 0; s -= 1)
        (r = l[s].split("=")[0]) === e && l.splice(s, 1);
      l.length && (o = o + "?" + l.join("&"));
    }
    return o;
  },
  renderUrl: function (e) {
    let t = document.querySelector(options.section).dataset.sectionId,
      r = `${window.location.pathname}?section_id=${t}&${e}`;
    return r;
  },
  renderSectionFilter: function (e, t) {
    this.toggleLoading(document.body, !0),
      fetch(`${e}`)
        .then((e) => {
          if (!e.ok) throw Error(e.status);
          return e.text();
        })
        .then((e) => {
          let t = new DOMParser()
            .parseFromString(e, "text/html")
            .querySelector(options.section);
          document.querySelector(options.section).replaceWith(t),
            document
              .querySelector(options.overlay)
              .classList.add("d-none-overlay"),
            document.documentElement.classList.remove("hside_opened"),
            this.toggleLoading(document.body, !1);
        })
        .catch((e) => {
          throw e;
        })
        .finally(() => {
          BlsReloadSpr.init(),
            BlsEventCollectionShopify.init(),
            BlsColorSwatchesShopify.init(),
            BlsSubActionProduct.init(),
            setTimeout(function () {
              BlsLazyloadImg.init();
            }, 200);
        }),
      this.updateUrl(e, t);
  },
  eventLoadMore: function () {
    document.querySelectorAll(options.collectionsLoadMore).forEach((e) => {
      var t = this;
      e.classList.contains("infinit-scrolling")
        ? new IntersectionObserver(
            function (r) {
              r.forEach((o) => {
                r.forEach((r) => {
                  1 === r.intersectionRatio && t.loadMoreProducts(e);
                });
              });
            },
            { threshold: 1 }
          ).observe(e)
        : e.addEventListener(
            "click",
            (e) => {
              e.preventDefault();
              let r = e.currentTarget;
              t.loadMoreProducts(r);
            },
            !1
          );
    });
  },
  loadMoreProducts: function (e) {
    let t = e.getAttribute("href");
    this.toggleLoading(e, !0),
      fetch(`${t}`)
        .then((e) => {
          if (!e.ok) throw Error(e.status);
          return e.text();
        })
        .then((t) => {
          let r = parser.parseFromString(t, "text/html"),
            o = r.querySelectorAll("#bls__product-grid .bls__grid__item");
          o.forEach((e) =>
            document.getElementById("bls__product-grid").appendChild(e)
          );
          let l = r.querySelector(".collections-load-more");
          (document.querySelector(".load-more-amount").innerHTML =
            r.querySelector(".load-more-amount").textContent),
            (document.querySelector(".load-more-percent").style.width =
              r.querySelector(".load-more-percent").style.width),
            l ? e.setAttribute("href", l.getAttribute("href")) : e.remove(),
            this.toggleLoading(e, !1);
        })
        .catch((e) => {
          throw e;
        })
        .finally(() => {
          BlsColorSwatchesShopify.init(),
            BlsSubActionProduct.init(),
            BlsReloadSpr.init(),
            setTimeout(function () {
              BlsLazyloadImg.init();
            }, 200);
        });
  },
  toggleLoading: function (e, t) {
    e &&
      (t
        ? e.classList.add("start", "loading")
        : (e.classList.add("finish"),
          setTimeout(function () {
            e.classList.remove("start", "loading", "finish");
          }, 500)));
  },
  updateUrl: function (e, t = !1) {
    if (t) {
      let r = `${window.location.pathname}?${t}`;
      window.history.pushState({ url: r }, "", r);
    } else window.history.pushState({ url: e }, "", e);
  },
};
BlsEventCollectionShopify.init();
